import { useState } from "react";
import share_default from "src/assets/lottie/share_default/share_default.lottie";
import Loading from "src/components/Loading";
import Lottie from "src/components/Lottie";
import { ShareModalPreviewProps } from "src/modals/configs/GlobalModal";
import { enumNever } from "src/shared/helpers/generalHelpers";
import { radiusMedium } from "src/styles/radius";
import { Image } from "src/swsh-native";

const ShareModalPreview = ({
	width,
	height,
	preview,
}: {
	width: number;
	height: number;
	preview: ShareModalPreviewProps | undefined;
}) => {
	const [isLoading, setIsLoading] = useState(true);
	if (!preview) {
		const size = Math.min(width, height);
		return (
			<Lottie
				source={share_default}
				style={{
					width: size,
					height: size,
				}}
			/>
		);
	}
	const { variant } = preview;
	switch (variant) {
		case "Image":
			const resolvedDim = preview.dim
				? typeof preview.dim === "function"
					? preview.dim({ width, height })
					: preview.dim
				: { width, height };
			return (
				<>
					<Image
						alt={preview.alt}
						src={preview.src}
						contentFit={preview.contentFit}
						onLoad={() => setIsLoading(false)}
						onError={() => setIsLoading(false)}
						dim={resolvedDim}
						style={{
							borderRadius: preview.borderRadius ?? radiusMedium,
						}}
					/>
					{isLoading && (
						<Loading
							style={{
								position: "absolute",
							}}
						/>
					)}
				</>
			);
		default:
			return enumNever(variant);
	}
};
export default ShareModalPreview;
